import { __awaiter, __generator } from "tslib";
import { sendTransactionalMessage } from '@office-start/message-listener';
export function deleteTrie(worker) {
    return __awaiter(this, void 0, void 0, function () {
        var deleteMessage;
        return __generator(this, function (_a) {
            deleteMessage = {
                type: "delete-trie" /* EdgeworthMessageType.DeleteTrie */,
                payload: {},
            };
            return [2 /*return*/, sendTransactionalMessage(deleteMessage, worker)];
        });
    });
}
//# sourceMappingURL=deleteTrie.js.map